import { render, staticRenderFns } from "./RecordEditor.vue?vue&type=template&id=e782e996&scoped=true"
import script from "./RecordEditor.vue?vue&type=script&lang=js"
export * from "./RecordEditor.vue?vue&type=script&lang=js"
import style0 from "./RecordEditor.vue?vue&type=style&index=0&id=e782e996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e782e996",
  null
  
)

export default component.exports